export const NAMESPACE = "foodoor_insights_cache_v2";
export const MAX_ENTRIES = 40;

export const yesterdayUtc = (now = new Date()) =>
  new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - 1))
    .toISOString()
    .slice(0, 10);

export const toQueryString = (params) =>
  Object.keys(params || {})
    .filter((key) => params[key] !== "" && params[key] !== null && params[key] !== undefined)
    .sort()
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join("&");

export const cacheKey = (userId, params) => `${userId}|${toQueryString(params)}`;

const load = () => {
  try {
    const raw = localStorage.getItem(NAMESPACE);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (e) {
    return {};
  }
};

const save = (entries) => {
  try {
    localStorage.setItem(NAMESPACE, JSON.stringify(entries));
  } catch (e) {
    try {
      localStorage.removeItem(NAMESPACE);
      localStorage.setItem(NAMESPACE, JSON.stringify(entries));
    } catch (again) {}
  }
};

export const readCache = (key, now = new Date()) => {
  const entry = load()[key];
  if (!entry || !entry.response || !entry.response.data_through) return null;
  return entry.response.data_through >= yesterdayUtc(now) ? entry.response : null;
};

export const writeCache = (key, response, now = new Date()) => {
  const entries = load();
  entries[key] = { saved_at: now.getTime(), response };
  const keys = Object.keys(entries).sort((a, b) => entries[a].saved_at - entries[b].saved_at);
  while (keys.length > MAX_ENTRIES) delete entries[keys.shift()];
  save(entries);
};

export const clearInsightsCache = () => {
  try {
    localStorage.removeItem(NAMESPACE);
  } catch (e) {}
};
